import {Component,Inject, Input} from 'ng-metadata/core';



import { LoginHelpService } from './loginHelp.service';
//your imports go here
import {AuthenticationMethod} from '../../../appConfig/appConfigForward';

@Component({
selector: 'prm-login-help',
templateUrl: 'components/security/login/loginHelp/login-help.html',
})



export class PrmLoginHelp{
    @Input() private authenticationMethod: AuthenticationMethod;

    private _showMoreInfo: boolean = false;
    private _showMoreInfoButton: boolean;

    constructor(private loginHelpService: LoginHelpService,
                @Inject('loginIcons') public loginIcons) {
    }

    get displaySigninHelp() {
        return this.loginHelpService.displaySigninHelp;
    }

    public toggleShowMoreInfo() {
        this._showMoreInfo = !this._showMoreInfo;
    }

    get showMoreInfoButton() {
        if ( this.loginHelpService.loginHelpData.links &&
             this.loginHelpService.loginHelpData.links.length === 1 &&
             !this.loginHelpService.loginHelpData.description ) {
            // Only one link is defined, display it with no more info button
            this._showMoreInfoButton = false;
            this._showMoreInfo = true;
        }
        else {
            // Display more info button
            this._showMoreInfoButton = true;
        }

        return this._showMoreInfoButton;
    }

    get showMoreInfo() {
        return this._showMoreInfo;
    }

    get loginHelpLinks() {
        if ( this.loginHelpService.loginHelpData ) {
            return this.loginHelpService.loginHelpData.links;
        }
        else {
            return [];
        }
    }

    get showHelpDescription() {
        if ( this.loginHelpService.loginHelpData &&
             this.loginHelpService.loginHelpData.description ) {
            return 1;
        }
        else {
            return 0;
        }
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/components/security/login/loginHelp/loginHelp.directive.ts